// movies all
export const GET_MOVIES_SUCCESS = 'GET_MOVIES_SUCCESS';
export const GET_MOVIES_FAIL = 'GET_MOVIES_FAIL';
export const GET_MOVIES_REQUESTED = 'GET_MOVIES_REQUESTED';

// movies page 1
export const GET_PAGE1_SUCCESS = 'GET_PAGE1_SUCCESS';
export const GET_PAGE1_FAIL = 'GET_PAGE1_FAIL';
export const GET_PAGE1_REQUESTED = 'GET_PAGE1_REQUESTED';

// movies page 2
export const GET_PAGE2_SUCCESS = 'GET_PAGE2_SUCCESS';
export const GET_PAGE2_FAIL = 'GET_PAGE2_FAIL';
export const GET_PAGE2_REQUESTED = 'GET_PAGE2_REQUESTED';

// movies page 3
export const GET_PAGE3_SUCCESS = 'GET_PAGE3_SUCCESS';
export const GET_PAGE3_FAIL = 'GET_PAGE3_FAIL';
export const GET_PAGE3_REQUESTED = 'GET_PAGE3_REQUESTED';

// movies page 4
export const GET_PAGE4_SUCCESS = 'GET_PAGE4_SUCCESS';
export const GET_PAGE4_FAIL = 'GET_PAGE4_FAIL';
export const GET_PAGE4_REQUESTED = 'GET_PAGE4_REQUESTED';

// movies action
export const GET_MOVIES_ACTION_SUCCESS = 'GET_MOVIES_ACTION_SUCCESS';
export const GET_MOVIES_ACTION_FAIL = 'GET_MOVIES_ACTION_FAIL';
export const GET_MOVIES_ACTION_REQUESTED = 'GET_MOVIES_ACTION_REQUESTED';

// movies thriller
export const GET_MOVIES_THRILLER_SUCCESS = 'GET_MOVIES_THRILLER_SUCCESS';
export const GET_MOVIES_THRILLER_FAIL = 'GET_MOVIES_THRILLER_ACTION_FAIL';
export const GET_MOVIES_THRILLER_REQUESTED = 'GET_MOVIES_THRILLER_REQUESTED';

// movies comedy
export const GET_MOVIES_COMEDY_SUCCESS = 'GET_MOVIES_COMEDY_SUCCESS';
export const GET_MOVIES_COMEDY_FAIL = 'GET_MOVIES_COMEDY_FAIL';
export const GET_MOVIES_COMEDY_REQUESTED = 'GET_MOVIES_COMEDY_REQUESTED';

// movies Romance 
export const GET_MOVIES_ROMANCE_SUCCESS = 'GET_MOVIES_ROMANCE_SUCCESS';
export const GET_MOVIES_ROMANCE_FAIL = 'GET_MOVIES_ROMANCE_FAIL';
export const GET_MOVIES_ROMANCE_REQUESTED = 'GET_MOVIES_ROMANCE_REQUESTED';

// movies wibu
export const GET_MOVIES_WIBU_SUCCESS = 'GET_MOVIES_WIBU_SUCCESS';
export const GET_MOVIES_WIBU_FAIL = 'GET_MOVIES_WIBU_FAIL';
export const GET_MOVIES_WIBU_REQUESTED = 'GET_MOVIES_WIBU_REQUESTED';

// movie details
export const SET_MOVIE_DETAIL = 'SET_MOVIE_DETAIL';

// profile
export const SET_PROFILE_DETAIL = 'SET_PROFILE_DETAIL';